import React, { useState, useEffect, useRef } from "react";
import { noImg } from "vrcore-dashboard/dist/utilities";
import { Grid, IconButton, Button, Typography } from "@material-ui/core";

import { Remove as RemoveIcon, AddBox as AddBoxIcon } from "@material-ui/icons";

export default (props) => {
    const [profile, setProfile] = useState(props.profile);
    const [limitExceeded, setLimitExceeded] = useState(false);
    const ref = useRef();
    useEffect(() => {
        setProfile(props.profile);
    }, [props.profile]);
    const { attached_photos = [] } = profile;
    return (
        <Grid item xl={12} xs={12}>
            <Typography
                style={{ marginLeft: 24, marginBottom: 30 }}
                variant="h5"
            >
                Attached Photo's:
            </Typography>
            <Grid container spacing={4}>
                {attached_photos &&
                    attached_photos.map((e, i) => {
                        return (
                            <Grid
                                xl={3}
                                lg={3}
                                xs={12}
                                sm={12}
                                md={6}
                                style={{ position: "relative" }}
                            >
                                {props.pageType !== "view" && (
                                    <IconButton
                                        mini
                                        aria-label="delete"
                                        onClick={() => {
                                            let items = attached_photos;
                                            items.splice(i, 1);
                                            props.setData(
                                                "attached_photos",
                                                items
                                            );
                                        }}
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            right: 0,
                                            background: "red",
                                            color: "white",
                                            height: 16,
                                            width: 16,
                                        }}
                                        size="small"
                                    >
                                        <RemoveIcon fontSize="inherit" />
                                    </IconButton>
                                )}
                                <img
                                    style={{
                                        padding: "16px",
                                        borderRadius: "32px",
                                        width: "100%",
                                        height: "95%",
                                    }}
                                    src={e ? e : noImg}
                                    alt={e ? e : noImg}
                                />
                            </Grid>
                        );
                    })}
                {limitExceeded && (
                    <div
                        style={{
                            background: "red",
                            color: "white",
                            borderRadius: "50%",
                            padding: 4,
                        }}
                    >
                        Too Many Images Selected - Limit is 4 Images
                    </div>
                )}
                <input
                    type="file"
                    id="file"
                    accept="image/*"
                    ref={ref}
                    multiple
                    style={{ display: "none" }}
                    onChange={(event) => {
                        if (event.target.files[0].size > 1000000) {
                            this.setState({
                                fileMaxSizeSnackbar: true,
                            });
                        } else {
                            let local = attached_photos;

                            let total =
                                event.target.files.length +
                                attached_photos.length;
                            if (event.target.files.length > 0 && total < 5) {
                                setLimitExceeded(false);
                                Object.keys(event.target.files).map((f) => {
                                    props.uploadFile(
                                        profile.toolbox_topic,
                                        event.target.files[f],
                                        (status) => {
                                            if (status.url) {
                                                local.push(status.url);
                                                props.setData(
                                                    "attached_photos",
                                                    local
                                                );
                                            }
                                        }
                                    );
                                    return null;
                                });
                            } else setLimitExceeded(true);
                        }
                    }}
                />
                {props.pageType !== "view" && attached_photos.length < 4 && (
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => {
                            ref.current.click();
                        }}
                        style={{
                            margin: "inherit",
                            background: "#0188cc",
                            color: "white",
                        }}
                    >
                        <AddBoxIcon /> Select Photo(s)
                    </Button>
                )}
            </Grid>
        </Grid>
    );
};
